import React from "react";
import {Link} from "react-router-dom";

import {useUserLogin} from "../shared/UserLogin";
import {
    Nav,
    Spinner,
    Header,
    HeaderButtonBack,
    Dropdown,
} from "@deere/ux.uxframe-react";
import {ReactComponent as HomeIcon} from "@deere/ux.brand-foundations/icons/home.svg";
import {
    CAMPAIGNS,
    CRITERIA_CATALOG,
    FEEDBACK_REQUESTED, GROUP_MAINT,
    HOME, RATING_PROGRAMS,
    RATING_TEAMS,
    SUPPLIER_MAINT,
    SUPPLIER_RATINGS
} from "../shared/Constants";

const NavBar = ({info}) => {
    const isCriteriaAdmin = info && info.isCriteriaAdmin;
    const isSupplier = info && info.isSupplier;

    return (
        <React.Fragment>
            <Nav.Item className="uxf-nav-item-icon">
                <a href="http://jdsn.deere.com" className="nav-icon" aria-label="home page">
                    <HomeIcon className="nav-home-icon"/>
                </a>
            </Nav.Item>
            <Dropdown as={Nav.Item} className="active">
                <Dropdown.Toggle as={Nav.Link} id="currentApp">
                    <span className="uxf-link-text">Achieving Excellence</span>
                </Dropdown.Toggle>
                <Dropdown.Menu renderOnMount style={{zIndex: 9999}}>
                    <HeaderButtonBack>Menu</HeaderButtonBack>
                    {isSupplier ?
                        <>
                            <Dropdown.Item as={Link} to="/">{HOME}</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/ratings">{SUPPLIER_RATINGS}</Dropdown.Item>
                        </>
                        :
                        <>
                            <Dropdown.Item as={Link} to="/">{HOME}</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/criteria-catalog">{CRITERIA_CATALOG}</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/campaigns">{CAMPAIGNS}</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/feedback">{FEEDBACK_REQUESTED}</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/rating-teams">{RATING_TEAMS}</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/supplier-mnt">{SUPPLIER_MAINT}</Dropdown.Item>
                            <Dropdown.Item as={Link} to="/ratings">{SUPPLIER_RATINGS}</Dropdown.Item>
                            {isCriteriaAdmin &&
                                <>
                                    <Dropdown.Item as={Link} to="/rating-programs">{RATING_PROGRAMS}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to="/groups">{GROUP_MAINT}</Dropdown.Item>
                                </>
                    }
                        </>
                    }
                </Dropdown.Menu>
            </Dropdown>
            <Nav.Item>
                <Nav.Link href={process.env.REACT_APP_JDSN_APPLICATIONS_HOME} target="_blank">
                    <span className="uxf-link-text">Applications</span>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link href={process.env.REACT_APP_JDSN_APPLICATIONS_HELP} target="_blank">
                    <span className="uxf-link-text">Help</span>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link href={process.env.REACT_APP_JDSN_APPLICATIONS_CONTACT_US} target="_blank">
                    <span className="uxf-link-text">Contact Us</span>
                </Nav.Link>
            </Nav.Item>
        </React.Fragment>
    );
}


const searchJDSN = (e) => {
    const searchText = e.target.uxfsearchinput.value;
    window.open(
        "https://jdsn.deere.com/wps/myportal/jdsn/Home/SupplierSearch?sources=" +
        escape(searchText),
        "JDSN Search"
    );
    e.preventDefault();
}

export default function AEHeader() {
    const [userInfo, logout, userObj] = useUserLogin();

    const HeaderDropdown = (
        <Dropdown alignRight>
            <Dropdown.Toggle variant="link" size="sm" aria-label="account menu">
                Hi,{" "}
                <span className="uxf-header-title-username">
					{userInfo && userInfo.given_name}
				</span>{" "}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item onClick={logout}>Sign out</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );

    return (
        <>
            {userInfo && (
                <Header
                    inputProps={{ariaLabel: "Search", name: "uxfsearchinput"}}
                    submitBtnProps={{ariaLabel: "Search"}}
                    formProps={{onSubmit: searchJDSN}}
                    clearBtnProps={{ariaLabel: "Clear search"}}
                    logoLink="http://deere.com"
                    headerTitleComponent={HeaderDropdown}
                    skipLink="#content"
                    pageHeading="Supply Network"
                    pageHeadingLink="http://jdsn.deere.com"
                >
                    <NavBar info={userObj}/>
                </Header>
            )}
            {userInfo === null && (
                <div className="d-flex w-100 justify-content-center align-items-center">
                    <Spinner className="uxf-spinner-border-lg" animation="border"/>
                    <p className="uxf-spinner-border-inline-text">Please Wait...</p>
                </div>
            )}
        </>
    );
}
